import { render, staticRenderFns } from "./SignUpPagePassword.vue?vue&type=template&id=18fe04f6&scoped=true&"
import script from "./SignUpPagePassword.vue?vue&type=script&lang=js&"
export * from "./SignUpPagePassword.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPagePassword.vue?vue&type=style&index=0&id=18fe04f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe04f6",
  null
  
)

export default component.exports